import React from "react";
import { SOCIALS } from "../../lib/memeData";

const colorClass = (c) =>
  c === "blue"
    ? "crayon-btn--blue"
    : c === "green"
    ? "crayon-btn--green"
    : c === "red"
    ? "crayon-btn--red"
    : c === "yellow"
    ? "crayon-btn--yellow"
    : "";

export const Socials = () => {
  return (
    <section id="socials" className="px-5 md:px-10 py-14" data-testid="socials-section">
      <div className="max-w-5xl mx-auto crayon-card relative px-6 md:px-10 py-10 text-center rotate-1">
        <span className="tape" style={{ background: "rgba(42, 157, 143, 0.55)" }} />
        <h2 className="font-display text-5xl md:text-7xl">
          join the <span className="text-[#E8742C]">retard alliance</span>
        </h2>
        <p className="text-lg md:text-xl text-[#1A1A1A]/70 mt-2">
          we're live ✦ click anything below to join the retard alliance
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-3 md:gap-4">
          {SOCIALS.map((s, idx) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer noopener"
              className={`crayon-btn ${colorClass(s.color)}`}
              data-testid={`social-link-${idx}`}
            >
              {s.emoji} ─ {s.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Socials;
